<template>
    <div>
        <div class="row my-4">
            <div class="col-12">
                <h1 class="text-3xl ps-2" v-html="$t('Manuell betaling <br><strong>via nettbank</strong>')"></h1>
            </div>
            <div class="col-12">
                <div class="card mb-3">
                    <div class="row no-gutters">
                        <div class="col-2">
                            <div class="card-body text-elev-blue">
                                <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10.496 2.132a1 1 0 00-.992 0l-7 4A1 1 0 003 8v7a1 1 0 100 2h14a1 1 0 100-2V8a1 1 0 00.496-1.868l-7-4zM6 9a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm3 1a1 1 0 012 0v3a1 1 0 11-2 0v-3zm5-1a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </div>
                        </div>
                        <div class="col-10">
                            <div class="card-body pb-1">
                                <h5 class="card-title text-xs mb-0">{{ amountLabel }}</h5>
                                <p class="text-2xl mb-0"><strong>{{ balanceAmount }} kr</strong></p>
                            </div>
                            <div class="card-body py-1" v-show="accountNumber">
                                <h5 class="card-title text-xs mb-0">{{ $t('Kontonummer') }}:</h5>
                                <p class="text-2xl mb-0"><strong>{{ accountNumber }}</strong></p>
                            </div>
                            <div class="card-body pt-1" v-show="studentKID">
                                <h5 class="card-title text-xs mb-0">{{ $t('KID') }}:</h5>
                                <p class="text-2xl mb-0"><strong>{{ studentKID }}</strong></p>
                            </div>
                            <div class="card-body pt-1" v-show="accountNumber">
                                <div class="alert alert-info">
                                    {{ $t('Betalingen gjøres med befriende virkning til TABS AS, som mottar betalingen på vegne av og etter avtale med trafikkskolen.') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-show="!studentKID || !accountNumber">
            <div class="col-12">
                <div class="alert alert-info text-center">
                    {{ $t('Vennligst ta kontakt med din trafikkskole for betalingsinformasjon') }}
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    label {
        word-break: break-word;
        hyphens: auto;
    }
</style>
<script setup>
import { computed } from 'vue';
import Store from '../../state/paymentStore';
import { toMoney } from "../../lib/format";

const amountLabel = computed(() => Store.getBalanceAmountLabel());
const balanceAmount = computed(() => toMoney(Store.getBalanceAmount()));
const studentKID = computed(() => Store.getStudentKID());
const accountNumber = computed(() => Store.getAccountNumber());
</script>
